import { render, staticRenderFns } from "./ReusableDisclaimerModal.vue?vue&type=template&id=3ca3ff29&"
import script from "./ReusableDisclaimerModal.vue?vue&type=script&lang=js&"
export * from "./ReusableDisclaimerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports